// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  padding: 0;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
p {
  margin: 0;
  padding: 0;
}
.container1 {
  width: 80%;
  margin-right: auto;
  margin-left: auto;
}
.brand-section {
  background-color: #0d1033;
  padding: 10px 40px;
}
.logo {
  width: 50%;
}

.row {
  display: flex;
  flex-wrap: wrap;
}
.col-6 {
  width: 50%;
  flex: 0 0 auto;
}
.text-white {
  color: #fff;
}
.company-details {
  float: right;
  text-align: right;
}
.body-section {
  padding: 16px;
  border: 1px solid gray;
}
.heading {
  font-size: 20px;
  margin-bottom: 08px;
}
.sub-heading {
  color: #262626;
  margin-bottom: 05px;
}
.table-bordered table thead tr {
  border: 1px solid #111;
  /* background-color: black; */
}
table td {
  vertical-align: middle !important;
  /* text-align: center !important; */
}

/* tbody > tr > td:first-child {
    text-align: left !important;
} */

.table-bordered {
  box-shadow: 0px 0px 5px 0.5px gray;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #dee2e6;
}
.text-right {
  text-align: end;
}
.w-20 {
  width: 20%;
}
.float-right {
  float: right;
}
@media print {
  .printbtn {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/Invoice.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;;;;;;EAME,SAAS;EACT,UAAU;AACZ;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;;GAEG;;AAEH;EACE,kCAAkC;AACpC;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["body {\n  margin: 0;\n  padding: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n}\np {\n  margin: 0;\n  padding: 0;\n}\n.container1 {\n  width: 80%;\n  margin-right: auto;\n  margin-left: auto;\n}\n.brand-section {\n  background-color: #0d1033;\n  padding: 10px 40px;\n}\n.logo {\n  width: 50%;\n}\n\n.row {\n  display: flex;\n  flex-wrap: wrap;\n}\n.col-6 {\n  width: 50%;\n  flex: 0 0 auto;\n}\n.text-white {\n  color: #fff;\n}\n.company-details {\n  float: right;\n  text-align: right;\n}\n.body-section {\n  padding: 16px;\n  border: 1px solid gray;\n}\n.heading {\n  font-size: 20px;\n  margin-bottom: 08px;\n}\n.sub-heading {\n  color: #262626;\n  margin-bottom: 05px;\n}\n.table-bordered table thead tr {\n  border: 1px solid #111;\n  /* background-color: black; */\n}\ntable td {\n  vertical-align: middle !important;\n  /* text-align: center !important; */\n}\n\n/* tbody > tr > td:first-child {\n    text-align: left !important;\n} */\n\n.table-bordered {\n  box-shadow: 0px 0px 5px 0.5px gray;\n}\n.table-bordered td,\n.table-bordered th {\n  border: 1px solid #dee2e6;\n}\n.text-right {\n  text-align: end;\n}\n.w-20 {\n  width: 20%;\n}\n.float-right {\n  float: right;\n}\n@media print {\n  .printbtn {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
